export * from './src/addons-v1-add-on-add-ons.meta.js';
